import React, { type JSX } from 'react'

function DescriptionListRaw(props: React.ComponentPropsWithoutRef<'dl'>) {
  return <dl {...props} />
}

function DescriptionTerm(props: React.ComponentPropsWithoutRef<'dt'>) {
  const { labelId } = React.useContext(LabelContext)
  return <dt role="term" {...props} id={labelId} />
}

function DescriptionDetails(props: React.ComponentPropsWithoutRef<'dd'>) {
  const { labelId } = React.useContext(LabelContext)
  return <dd {...props} role="definition" aria-labelledby={[props['aria-labelledby'], labelId].filter(Boolean).join(' ')} />
}

function DescriptionItem<As extends keyof JSX.IntrinsicElements | React.JSXElementConstructor<any> = 'div'>({
  labelId: labelRaw,
  as: Comp = 'div',
  ...props
}: { labelId?: string; as?: React.ComponentType } & React.ComponentProps<As>) {
  const labelId = React.useId()
  return (
    <LabelContext.Provider value={{ labelId: labelRaw ?? labelId }}>
      <Comp {...props} />
    </LabelContext.Provider>
  )
}

const LabelContext = React.createContext<{ labelId: string }>({ labelId: '' })

export const DescriptionList = Object.assign(DescriptionListRaw, {
  Term: DescriptionTerm,
  Details: DescriptionDetails,
  Group: DescriptionItem
})
